import { IModelBase } from "@pmis3/core";
import { ILocationForNOA } from "@pmis3/master-data-core";
import { VesselTransitStatus } from "./vessel-visit";
import { IVesselMovement } from "../../vessel-movement";
import { IVesselStop } from "../../vessel-stop";
import { IVesselActivityPurpose } from "./vessel-activity-purpose-enum";
import { IServiceApplication } from "./service-application";
import { IEditFlagBaseObject } from "./edit-flag";
import { VesselStopTypeForStepper } from "../../vessel-stop";

export interface IVesselActivity extends IModelBase, IEditFlagBaseObject {
    estimatedStartTime?: Date;
    startTime?: Date;
    estimatedEndTime?: Date;
    endTime?: Date;
    startLocationId?: number;
    startLocation?: ILocationForNOA;
    endLocationId?: number;
    endLocation?: ILocationForNOA;
    vesselVisitId?: number;
    // status?: VesselTransitStatus;

    purposes?: IVesselActivityPurpose[];
    purposesId?: number[];
    maxDisplacement?: number;
    statusId?: number;
    vfpaStatus?: number;
    ppaStatus?: number;
    serviceApplications?: IServiceApplication[]
    remarks?: string;
    activityType: VesselActivityType;
}

export type VesselActivityPair = {
    movement: IVesselMovement,
    stop?: IVesselStop
}

export enum VesselActivityType {
    Stop,
    Movement
}

export type VesselActivityIndicesAndStopType = {
	index: number;
	type: VesselStopTypeForStepper | string;
}